import { useEffect, useState, useRef } from 'react';
import {
    Container,
    Typography,
    TextField,
    RadioGroup,
    FormControlLabel,
    Radio,
    Button,
    FormControl,
    FormLabel,
} from '@material-ui/core';

import { doSpeechRecog, initSpeechRecognition } from './speechRecognition.js';



export default function AudioTest({ }) {
    const READY = 0;
    const RUNNING = 1;
    const FINISHED = 2;

    const [text, setText] = useState('');
    const [testRunningStatus, setTestRunningStatus] = useState(READY);
    const speechRecognitionControl = useRef();

    useEffect(() => {
    }, []);

    function finishTest() {
        speechRecognitionControl.current.stop();
        setTestRunningStatus(FINISHED);
    }

    async function beginTest() {
        setTestRunningStatus(RUNNING);
        const finalRecog = (text) => {
            setText(text);
            setTestRunningStatus(FINISHED);
        }
        speechRecognitionControl.current = await doSpeechRecog(finalRecog, setText, 10000);
    }

    return (
        <Container component="main" maxWidth="sm">
            <Typography variant="h3">Audio Test</Typography>

            <Typography paragraph>
                Let's test your microphone &#127908;
            </Typography>

            {testRunningStatus == READY && <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={beginTest}
                        style={{ margin: '24px 0' }}
                    >
                        Begin Test
                    </Button>
            }

            
            <Typography paragraph>
                {testRunningStatus == RUNNING &&
                    <div>
                    Please speak into your microphone. You should see the text appear below.
                    </div>
                }
                {(testRunningStatus == RUNNING || testRunningStatus == FINISHED) &&
                    <div>
                        You said:
                        <div style={{ color: 'darkred', backgroundColor: 'lightgrey' }}>&nbsp;{text}</div>
                    </div>
                }
                {(testRunningStatus == RUNNING) &&
                    <Button variant="contained" color="primary" onClick={finishTest}>Stop</Button>
                }
            </Typography>

            {testRunningStatus == FINISHED &&
            <Typography paragraph>
                You are ready to proceed!
                <Button fullWidth variant="contained" color="primary" onClick={() => { window.location = '/chat'; }}>Continue</Button>
            </Typography>
            }   



        </Container>
    );
}
